<script setup lang="ts">
import { getArticleList, getArticleDetail } from "@carnet/api/backoffice";
import type { ArticleResource, ArticleResourceDetailed } from "@carnet/api/backoffice";

// Le caption porte le contexte « home », pas « homeFeature » : il n'arrive pas
// avec la liste et se charge séparément, par code.
const [{ data }, { data: caption }] = await Promise.all([
  useAsyncData<ArticleResource[]>(
    "articles-home-feature",
    async () => {
      const result = await getArticleList({ composable: "$fetch", path: { locale: appLocale() }, query: { context: "homeFeature" } });
      return result ?? [];
    },
    { getCachedData: cachedDataUnlessRefresh }
  ),
  useAsyncData<ArticleResourceDetailed | null>(
    "article-homeFeature-caption",
    async () => {
      const result = await getArticleDetail({ composable: "$fetch", path: { locale: appLocale(), code: "homeFeature-caption" } });
      return result?.data ?? null;
    },
    { getCachedData: cachedDataUnlessRefresh }
  ),
]);
const articles = computed(() => data.value ?? []);
</script>

<template>
  <div v-if="articles.length" class="bg-gradient max-2xl:bg-ocean max-2xl:bg-size-[100%_200%] max-2xl:bg-position-[center_top]">
    <AppSection :ui="{ base: 'py-16 lg:pt-10 lg:pb-20' }">
      <h2 class="text-3xl lg:text-4xl font-semibold mb-16 max-w-2xl">{{ caption?.title }}</h2>
      <ul class="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-4">
        <li
          v-for="article in articles"
          :key="article.code"
          class="lg:row-span-3 lg:odd:col-start-1 lg:even:col-start-2 lg:nth-2:row-start-2"
        >
          <article :key="article.code" class="h-full text-white bg-blue-800 rounded-2xl p-8 sm:py-10 sm:px-12 flex gap-x-2.5">
            <UIcon v-if="article.icon" :name="article.icon" class="size-8 shrink-0 text-lagoon-300" />
            <div>
              <h3 class="text-2xl/[1.08] font-semibold text-lagoon-300 not-last:mb-1 pt-1">
                {{ article.title }}
              </h3>
              <p v-if="article?.content" class="text-base/[1.4]">{{ article.content }}</p>
            </div>
          </article>
        </li>
      </ul>
    </AppSection>
  </div>
</template>
